import { createFileRoute } from '@tanstack/react-router'
import { TrackerListView } from '@/features/tracker/TrackerListView'

function Tracker() {
  const { asUser } = Route.useSearch()
  return <TrackerListView asUser={asUser} />
}

export const Route = createFileRoute('/tracker/')({
  // The lens lives in the URL so it is shareable and cannot become a hidden
  // sticky mode a staff member forgets they are in.
  validateSearch: (raw: Record<string, unknown>): { asUser?: string } => ({
    asUser: typeof raw.asUser === 'string' && raw.asUser ? raw.asUser : undefined,
  }),
  component: Tracker,
})
